import { render, staticRenderFns } from "./RecipesNotes.vue?vue&type=template&id=73346b99"
import script from "./RecipesNotes.vue?vue&type=script&lang=js"
export * from "./RecipesNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports